// Filter for course category
jQuery(document).ready(function ($){
    $(".filter-button").each(function () {

		var inTotal = $('.item').length;
		$('.total-items').html(inTotal); 

        $(this).on("click", function () {
          $('.filter-button').removeClass('active');
          $(this).addClass('active');
          $('.item').removeClass('active');
          $('.filter-name').removeClass('active');
          $('.item[data-id*=' + $(this).attr('data-id') + ']').addClass('active');
          $('.filter-name[data-id*=' + $(this).attr('data-id') + ']').addClass('active');

		  var number = $('.item[data-id*=' + $(this).attr('data-id') + ']').length;
		  if ($(this).data('id') == 'all-items') {
			$('.total-items').html(inTotal); 
		  } else {
			$('.total-items').html(number);
		  }
		  

          if ($(this).data('id') == 'all-items') {
            $('.item').addClass('active');
          }
        });
    });
});